import {
  faTrashCan as DeleteIcon,
  faPen as EditIcon
} from '@fortawesome/pro-light-svg-icons';
import { faEllipsisVertical as MoreIcon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';
import {
  bindMenu,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks';
import { useLocation } from 'react-router';

import useConfirm from '@/hooks/useConfirm';
import { useDeleteAsset } from '@/pages/Asset/Asset.store';
import { selectedAssetAtom, selectedAssetIdAtom } from '@/pages/Assets';

const AssetActionsButton = ({
  showEdit,
  onEdit
}: {
  showEdit?: boolean;
  onEdit?: () => void;
}) => {
  const { deleteAsset } = useDeleteAsset();
  const [asset_id] = useAtom(selectedAssetIdAtom);
  const [selectedAsset] = useAtom(selectedAssetAtom);
  const { pathname } = useLocation();

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'moreMenu'
  });

  const { ConfirmationModal: AssetDeleteModal, confirm: confirmDelete } =
    useConfirm({
      title: pathname.includes('assets')
        ? `Delete Asset: ${selectedAsset?.asset_name}`
        : 'Delete',
      message: 'Please confirm that you want to delete this asset.',
      button: 'Delete'
    });

  const handleDelete = async () => {
    const confirmed = await confirmDelete();
    if (confirmed && asset_id) {
      deleteAsset(asset_id);
    }
    popupState.close();
  };

  const handleEdit = async () => {
    onEdit?.();
    popupState.close();
  };

  return (
    <>
      <Button color="primary" variant="outlined" {...bindTrigger(popupState)}>
        <FontAwesomeIcon icon={MoreIcon} />
      </Button>
      <Menu
        {...bindMenu(popupState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {showEdit && (
          <MenuItem onClick={handleEdit}>
            <ListItemIcon>
              <FontAwesomeIcon icon={EditIcon} size="lg" />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
        )}
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <Typography sx={{ color: 'error.main' }}>
              <FontAwesomeIcon icon={DeleteIcon} size="lg" />
            </Typography>
          </ListItemIcon>

          <ListItemText>
            <Typography sx={{ color: 'error.main' }}>Delete</Typography>
          </ListItemText>
        </MenuItem>
      </Menu>
      <AssetDeleteModal />
    </>
  );
};

export default AssetActionsButton;
